import { doctorCommissionId } from "./Operations/ProductAPI"

export const baseURL= 
  "https://admin.houseofdhanushdhari.com/api/" 
 
 //"https://rndsan.com/"

export const auth={
   login: baseURL+"rental/login",
   register:baseURL+'rental/register',
   getProfile:baseURL+'rental/profile',
   logoutUser:baseURL+'rental/logout',
   getHistory:baseURL+'rental/rental-payment-history'
  
}

export const property={
   getProperty:baseURL+'apartment-rental-property',
   getGallery:baseURL+'apartment-rental/gallery',
   createOrder:baseURL+'rental/create-order',
 verifyPayment:baseURL+'rental/verify-payment',
}

